<template>
    <InputDateTime
        v-model="model"
        v-bind="props"
        @submit="emit('submit', $event)"
    />
</template>

<script setup lang="ts">
import InputDateTime from '../InputDateTime/InputDateTime.vue'
import type { InputDateTimeProps } from '../InputDateTime/types'

defineOptions({ inheritAttrs: false })

const props = withDefaults(defineProps<Omit<InputDateTimeProps, 'modelValue'> & { focus?: boolean }>(), {
    format: 'YYYY-MM-DD',
})

const emit = defineEmits(['update:modelValue', 'submit'])

const model = defineModel<string>()
</script>
